import { featureToggle } from "@faire/web/common/settings/declarations/featureToggle";

/**
 * Setting to control whether the minimum exclusivity request is enabled.
 */
export const FE_ENABLE_UX_CAM_SESSION_RECORDING_250326 = featureToggle({
  name: "FE_ENABLE_UX_CAM_SESSION_RECORDING_250326",
  defaultValue: false,
  identifier: "RetailerToken",
  client: "RETAILER",
  productArea: "HOTJAR_CONFIG",
  notifyAfter: "2026-03-01",
});
